var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import OriginalEditField from '../../MaterialTable/EditField';
import MultilineTextField from '../../MaterialTable/MultilineTextField';
import YearPicker from '../../MaterialTable/YearPicker';
import MonthPicker from '../../MaterialTable/MonthPicker';
import OrderedQuantity from '../../atoms/OrderedQuantity';
var EditQuantityField = function (props) {
    var value = props.value, onChange = props.onChange;
    return React.createElement(OrderedQuantity, { value: value, max: Math.pow(2, 31), onChange: onChange });
};
var EditField = function (props) {
    switch (props.columnDef.field) {
        case 'remainingQuantity':
            return React.createElement(EditQuantityField, __assign({}, props));
        case 'producerComment':
        case 'processingMethod':
        case 'note':
            return React.createElement(MultilineTextField, __assign({}, props));
        case 'harvestYear':
            return React.createElement(YearPicker, __assign({}, props));
        case 'harvestMonth':
            return React.createElement(MonthPicker, __assign({}, props));
        default:
            return React.createElement(OriginalEditField, __assign({}, props));
    }
};
export default EditField;
